export default __webpack_public_path__ + "static/media/Arcadis.ed02fa34.png";